import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const ImpersonationBanner = () => {
  const { isImpersonating, user, originalAdmin, stopImpersonation } = useAuth();

  const handleStopImpersonation = async () => {
    const result = await stopImpersonation();
    if (result.success) {
      toast.success('Returned to your admin session');
      // Full page reload to ensure all state is cleared and re-fetched with admin context
      window.location.href = '/dashboard';
    } else {
      toast.error(result.error || 'Failed to exit impersonation');
    }
  };

  return (
    <div
      className="collapsible-panel"
      data-open={isImpersonating}
    >
      <div className="collapsible-inner">
    <div className="bg-amber-500 text-amber-950">
      <div className="pl-72 pr-4 py-2 sm:pr-6 lg:pr-8">
        <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2">
          <div className="flex items-center gap-x-3">
            <ExclamationTriangleIcon className="size-5 flex-shrink-0" />
            <p className="text-sm font-medium">
              <span className="hidden sm:inline">Impersonation Mode: </span>
              Viewing as{' '}
              <span className="font-bold">
                {user?.first_name} {user?.last_name}
              </span>
              <span className="mx-1.5 hidden sm:inline">|</span>
              <span className="hidden sm:inline text-amber-800">
                Role: {user?.role || 'user'}
              </span>
            </p>
          </div>
          <div className="flex items-center gap-x-3">
            <span className="text-xs text-amber-800 hidden md:inline">
              Logged in as: {originalAdmin?.first_name} {originalAdmin?.last_name}
            </span>
            <button
              type="button"
              onClick={handleStopImpersonation}
              className="inline-flex items-center gap-x-1.5 rounded-md bg-amber-600 px-2.5 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-amber-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600 transition-colors"
            >
              <XMarkIcon className="size-4" />
              Exit Impersonation
            </button>
          </div>
        </div>
      </div>
    </div>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
